module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Bold.1009f03.woff";